import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: `/404`,
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/views/PageNotFound.vue"),
  },
  {
    path: "/card/:id",
    name: "card",
    component: () => import("@/views/CardView.vue"),
  },
  {
    path: "/usercard/:id",
    name: "usercard",
    component: () => import("@/views/UserCardView.vue"),
  },
  {
    path: "/smartcard/:id",
    name: "smartcard",
    component: () => import("@/views/SmartCardView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
